import React, { useState } from "react";
import InventoryOptimizer from "./pages/InventoryOptimizer";
import Copilot from "./pages/Copilot";

const TABS = [
  { id: "inventory", label: "Demand Forecasting", icon: null },
  { id: "copilot", label: "Category Manager", icon: null },
];

const App = () => {
  const [activeTab, setActiveTab] = useState("inventory");

  return (
    <div className="h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#1e2a3a] flex flex-col flex-shrink-0">
        {/* Logo */}
        <div className="px-5 py-5">
          <div className="flex items-center gap-2.5">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="4" width="20" height="16" rx="3" stroke="#10b981" strokeWidth="2"/>
              <path d="M7 14l3-4 3 2 4-5" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="text-white font-semibold text-[15px]">Quick Commerce</span>
          </div>
        </div>

        {/* Nav Items */}
        <nav className="flex-1 px-3 pt-2 space-y-1">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full flex items-center gap-2.5 px-4 py-2.5 rounded-md text-[14px] transition ${
                activeTab === tab.id
                  ? "bg-[#2d4a5e] text-white font-medium"
                  : "text-slate-400 hover:text-slate-200 hover:bg-[#263545]"
              }`}
            >
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 min-w-0 overflow-hidden">
        <div className={activeTab === "inventory" ? "h-full" : "hidden"}>
          <InventoryOptimizer />
        </div>
        <div className={activeTab === "copilot" ? "h-full" : "hidden"}>
          <Copilot />
        </div>
      </main>
    </div>
  );
};

export default App;
